module.exports = __webpack_public_path__ + "img/icon_ricarica.7d3de6a1.png";